<template>
    <main :class="{ 'form-group--error': hasValidator ? validator.state[name].$error : false }">
        <div class="label">
            <span v-if="hasValidator">*</span>
            <span>{{ label }}</span>
        </div>
        <slot />
        <div class="error requiredFieldsMsg" v-if="hasValidator && !validator.state[name].required">
            <el-alert :title="getValidationMessageFromKey(name)" type="error"></el-alert>
        </div>
    </main>
</template>

<script>
  import { getValidationMessageFromKey } from './data.js';
  export default {
    props: ['name', 'label', 'validator','hideValidator'],
    methods: {
      getValidationMessageFromKey
    },
    computed: {
      hasValidator() {
        return this.validator && this.validator.state[this.name] && !this.hideValidator;
      }
    }
  }
</script>

<style scoped>
    .label {
        font-weight: bold;
        text-align: left;
        display: flex;
        gap: 0.25rem;
    }
    .form-control {
        margin-bottom: 0;
    }
</style>